// extracted by mini-css-extract-plugin
export var textInput = "_ki-0";